import { styled } from '../theme';

const PageTileSeparator = styled('div')(({ theme }) => ({
    marginTop: 60,
}));

export default PageTileSeparator;
